<template>
    <!-- 老师管理 -->
    <div class="campus-list">
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-input v-model="params.condition.orgname" placeholder="老师名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div>
            <el-button type="primary" icon="el-icon-plus" v-if="!isSelect" @click="openTeacherDialog('')">新增老师</el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="isSelect = true" v-if="!isSelect">批量删除</el-button>
            <el-button type="primary" v-if="isSelect" @click="deleteTeacher('')" :disabled="selection.length === 0">批量删除 ({{selection.length}})</el-button>
            <el-button type="primary" plain v-if="isSelect" @click="cancelDelete">取消批量删除</el-button>
        </div>
        <div class="mt-15">
            <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" @selection-change="handleSelectionChange" ref="table" :row-key="getRowKey">
                <el-table-column type="selection" v-if="isSelect" fixed key="selection" class-name="selection" align="right" :width="getTableHeaderWidthByCheckCol(isSelect)"></el-table-column>
                <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                    <template slot-scope="scope">
                        <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                    </template>
                </el-table-column>
                <el-table-column prop="orgname" label="老师名称" fixed align="center" width="150" key="orgname" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="flex al-c">
                            <img class="img" :src="scope.row.logourl ? scope.row.logourl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" alt="">
                            <p style="line-height:40px;" class="text-ellipse">{{scope.row.orgname}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="propname" label="机构名称" align="center" width="200" key="propname" :formatter="formatTab" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="dutyname" label="职位" align="center" width="150" key="dutyname" :formatter="formatTab">
                    <template slot-scope="scope">
                        <p class="text-ellipse">{{scope.row.dutyname ? scope.row.dutyname : '--'}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="orgdesp" label="简介" align="center" min-width="400" key="orgdesp" show-overflow-tooltip :formatter="formatTab"></el-table-column>
                <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton2()" key="edit" v-if="!isSelect">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sa ai-c pointer">
                            <p @click="openTeacherDialog(scope.row.code)">编辑</p>
                            <p @click="deleteTeacher(scope.row)">删除</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        </div>
        <TeacherDialog ref="TeacherDialog" @saveSuccess="saveSuccess"></TeacherDialog>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getTeacherList,
  updateTeacherStatus
} from '@/api/measApi/teacherManage.js'
import TeacherDialog from './components/teacherDialog.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          orgname: '',
          innerid: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      isSelect: false,
      tableData: [],
      total: 0,
      selection: [],
      contentLoading: false
    }
  },
  components: {
    TableSort,
    Page,
    TeacherDialog
  },
  created() {
    this.getTeacherList()
  },
  methods: {
    //   获取表格数据
    getTeacherList() {
      this.contentLoading = true
      getTeacherList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getTeacherList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          orgname: '',
          innerid: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getTeacherList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getTeacherList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getTeacherList()
    },
    // 多选
    getRowKey(row) {
      return row.code
    },
    getdisabled(row) {
      return row.isedit
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 选择
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 取消批量删除
    cancelDelete() {
      this.isSelect = false
      this.$refs.table.clearSelection()
      this.selection = []
    },
    // 打开新增编辑
    openTeacherDialog(code) {
      this.$refs.TeacherDialog.handleOpen(code)
    },
    // 保存成功
    saveSuccess() {
      this.params.page = 1
      this.getTeacherList()
    },
    // 删除
    deleteTeacher(row) {
      this.$confirm('老师删除后将不在前台展示，继续吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          let code = ''
          if (row) {
            code = row.code
          } else {
            let selectionCode = []
            this.selection.map(item => {
              selectionCode.push(item.code)
            })
            code = selectionCode.join(',')
          }
          updateTeacherStatus({ code: code }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getTeacherList()
              this.isSelect = false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__empty-block {
  background: none;
}
.img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 10px;
}
</style>

